// extracted by mini-css-extract-plugin
export default {"container":"RemoveContainer_container__a1ZDV","field":"RemoveContainer_field__QMcjz","removeContainer":"RemoveContainer_removeContainer__QBIpE"};